// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi_map.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { PoiMapService } from "./poi_map_pb";

/**
 * GetPoiGeojson returns a GeoJSON FeatureCollection of a city's active POIs,
 * optionally narrowed to a set of category keys, as a JSON string.
 *
 * @generated from rpc travplaces.v1.PoiMapService.GetPoiGeojson
 */
export const getPoiGeojson = PoiMapService.method.getPoiGeojson;
